import { fromJS } from 'immutable';

export default {
    setNotifications: (state, notifications) => {
        return state.setIn(['list'], fromJS(notifications)).set('initialized', true);
    },
    setNotificationDetails: (state, notification) => {
        return state.mergeIn(['list'], fromJS(notification));
    },
    updateNotificationDetails: (state, notification) => {
        return state.mergeIn(['list'], fromJS(notification));
    },
    addNotification: (state, notificationId, notification) => {
        return state.setIn(['list', notificationId], fromJS(notification));
    },
    setDefaultNotificationsButtons: (state, buttons) => {
        return state.setIn(['defaultButtons'], fromJS(buttons));
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Notifications/core.js